import Vue from 'vue'
import axios from 'axios'
import createPersistedState from 'vuex-persistedstate'

import * as types from '../mutation-types/auth'


// set this true to namespace all getters, mutations, actions etc.
const namespaced = true
export const namespace = 'auth'

const helpers = {}

// state
const state = {
  auth: null,
  customer: null,
  loginFailed: false,
}

// mutations
const mutations = {
  [types.REGISTER](state, payload) {
    state.auth = null
  },
  [types.SET_CUSTOMER](state, payload) {
    state.customer = payload
  },
}

const actions = {
  register({ commit }, payload) {
    commit(types.REGISTER, payload)
  },
  setCustomer({ commit }, payload) {
    commit(types.SET_CUSTOMER, payload)
  },
}

// getters
const getters = {
  customer: state => state.customer,
  isFbUser: state => state.isFbUser === true,
}

// plugins
// const plugins = [createPersistedState({
//     key: 'racewaybooking-auth',
//     subscriber: () => {
//       console.log(arguments)
//     }
// })]
const plugins = []

const auth = {namespaced, namespace, state, mutations, actions, getters, plugins}
export default auth
